import Module from "utilities/global/sparta-module-utility/6.3.0/js/sparta-module-utility";
import ahCawCommons from "utilities/login/ah-caw-commons-utility/2.4.1/js/ah-caw-commons-utility";
import spartaValidationFramework from "utilities/global/sparta-validation-framework/7.1.8/js/sparta-validation-framework";
import jQuery from "utilities/vendor/jquery/3.5.1/js/jquery";
import $ from "utilities/vendor/jquery/3.5.1/js/jquery";
import handlebarsRuntime from "utilities/vendor/handlebars-runtime/4.7.7/js/handlebars.runtime";
import hb from "utilities/vendor/handlebars-runtime/4.7.7/js/handlebars.runtime";
import spartaStyleUtility from "utilities/global/sparta-style-utility/3.2.4/js/sparta-style-utility";
import cawEventsMasterUtility from "utilities/login/ah-caw-events-master-utility/4.5.3/js/ah-caw-events-master-utility";
import ahCawTransportUtility from "utilities/login/ah-caw-transport-utility/2.2.3/js/ah-caw-transport-utility";
import spartaMessageUtility from "utilities/global/sparta-messaging-utility/2.1.7/js/sparta-messaging-utility";
import spartaTemplates from "modules/login/ah-caw-cq-module/5.2.1/js/templates";
import "css!modules/login/ah-caw-cq-module/5.2.1/css/ah-caw-cq-module.scss.css";
export default class ahCawCqModel {
  constructor(parentModule) {
    this.parentModule = parentModule;

    const self = this;
    this.bindThisConext(['_initialize'],
        self, '');
  }

  bindThisConext(methods, context, suffix = 'Scoped') {
    const self = context;

    if (methods && $.isArray(methods) && methods.length > 0) {
      $(methods).each((index, method) => {
        if (self[method]) {
          self[method + suffix] = self[method].bind(context);
        } else {
          console.log(`Method: ${method} Not found in current context.`);
        }
      });
    }
  }

  _defineVars() {
    const _model = this.parentModule.model;
    this.$moduleContext = $(_model.settings.target);
    this.widgetConfigData = { intialized: false };
    return this;
  }

  _bindEventHandlers() {
    return this;
  }

  _listen() {
    const _model = this.parentModule.model;
    _model.listen({ context: 'update-challenge-question-data', caller: this, callback: this._updateCq});
    return this;
  }

  _updateCq(event,data){
      const _model = this.parentModule.model;
      if(data && data.stepUpToken && data.stepUpToken.processContext){
          this.parentModule.challengeQuestionData = data.stepUpToken.processContext.question;
          _model.emit({ context: 'update-challenge-question', data:   this.parentModule.challengeQuestionData});
      }else if(data && data.questions.length === 1){
         _model.emit({ context: 'update-challenge-question-Multi', data:   data.questions});
      }else if(data && data.questions.length > 1 ){
          _model.emit({ context: 'update-challenge-question-Multi', data:   data.questions});
      }
      else{

      }

  }

  _initialize() {
    this._defineVars()
        ._bindEventHandlers()
        ._listen();
  }
}
